
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { AuthGuard } from './shared/services/auth-guard.service';
import { WelcomeModule } from './welcome/welcome.module';
import { MasterModule } from './master/master.module';
import { SupportModule } from './support/support.module';
import { ConsultingModule } from './consulting/consulting.module';
import { DeveloperModule } from './developer/developer.module';
import { BusinessIntelligenceModule } from './business-intelligence/business-intelligence.module';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BillingModule } from './billing/billing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomerSuccessModule } from './customer-success/customer-success.module';
import { DataMeshModule } from './data-mesh/data-mesh.module';
import { AppConfigService } from './app-config.service';

export function initializeApp(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();
}

@NgModule({
  declarations: [
    
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    AuthModule,
    WelcomeModule,
    MasterModule,
    SupportModule,
    ConsultingModule,
    DeveloperModule,
    BusinessIntelligenceModule,
    BillingModule,
    BrowserAnimationsModule,
    CustomerSuccessModule,
    DataMeshModule,
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true
    },
    AuthGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
